<template>
	<div class="l-row--t128 l-row--t256l module c-sep">
		<div class="g-row l-mdl--8">
			<div class="g-col--6 g-col--2s">
				<div class="c-sep__txt i--brand">
					<div class="t-h--13"><span class="t--fak">{{ data.brand }}</span></div>
				</div>
			</div>
			<div class="g-col--9 g-col--3s">
				<div class="c-sep__txt">
					<div class="t-h--13 i--label-wrap"><span class="t--fak i--txt"><span class="t--ft">(</span><span class="i--label">{{ data.target.label }}</span><span class="t--ft">)</span></span></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import * as _ from "fxjs";
import { computed, onMounted, ref, reactive, watch, useStore } from "@/helper/vue.js";
import Picture from "@/parts/picture/PictureView.vue";

export default {
  props: ["idx", "bindRoot"],
	components: {
		Picture
	},
  setup(props) {
    const { get } = useStore();
		const self = ref();
		const data = reactive({
			brand: computed(() => get["from"](`${props.bindRoot}.brand`)),
			target: computed(() => get["from"](`${props.bindRoot}.modules.${props.idx}`)),
		});

    return {
			self,
			data,
    };
  },
};
</script>

<style scoped lang="scss"></style>